// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"852":"31d6cfe0","976":"a40ab908"}[chunkId] + ".chunk.css";
};